<path d="M9 3H21V48H9V3ZM30 3H42V48H30V3Z" fill="white" />
